import { useEffect, useState, type ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@chapche/ui'
import { propertySaveService } from '../../../services/propertySaveService'

const PropertyItemDescription = () => {
  const { i18n } = useTranslation()
  const [fieldValue, setFieldValue] = useState(
    () => propertySaveService.getProperty().description || '',
  )

  const changePropertyDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFieldValue(e.target.value)
    propertySaveService.updatePropertyValue('description', e.target.value)
  }

  const changePropertyData = () => {
    setFieldValue(propertySaveService.getProperty().description || '')
  }

  useEffect(() => {
    changePropertyData()
    propertySaveService.registerItemUpdateObserver(changePropertyData)
    return () =>
      propertySaveService.unRegisterItemUpdateObserver(changePropertyData)
  }, [])

  return (
    <label className="block__text product__form-label">
      <span className="product__form-label_text">
        {i18n.t('app.page.product.propertyItem.description')}
      </span>
      <textarea
        className={cn(
          'product__form-input mt-0 box-border w-full max-w-none resize-y',
          'rounded-input border border-solid border-light-grey bg-white',
          'px-16 py-12 font-montserrat-medium text-l text-ink',
          'placeholder:text-secondary-light-grey',
        )}
        rows={3}
        placeholder={i18n.t('app.page.product.propertyItem.text')}
        value={fieldValue || ''}
        onChange={changePropertyDescription}
      />
    </label>
  )
}

export default PropertyItemDescription
